const STORAGE_KEY = "moment:codeBlockLanguage";
const DEFAULT_LANGUAGE = "sh";

export function getPreferredCodeBlockLanguage(): string {
	try {
		return localStorage.getItem(STORAGE_KEY) ?? DEFAULT_LANGUAGE;
	} catch {
		return DEFAULT_LANGUAGE;
	}
}

export function setPreferredCodeBlockLanguage(language: string): void {
	try {
		localStorage.setItem(STORAGE_KEY, language);
	} catch {
		// Ignore storage errors
	}
}
